import mapKeys from 'lodash/mapKeys';
import { underscore } from 'inflected';

export const state = () => ({
  changes: [],
  meta: null,
  products: null
});

export const mutations = {
  clear (state) {
    state.changes = [];
    state.meta = null;
  },
  set (state, changes) {
    state.changes = changes;
  },
  setMeta (state, meta) {
    state.meta = mapKeys(meta, (_v, k) => underscore(k).replace('three', '3'));
  },
  setProducts (state, products) {
    state.products = products;
  }
};

export const getters = {
  get (state) {
    return state.changes;
  },
  getMeta (state) {
    return state.meta;
  },
  getProducts (state) {
    return state.products;
  }
};
